import React, { useEffect } from 'react'
import { Box, Grid } from '@mui/material'
import OverviewCard from '../Components/Overview/OvervewComponents/OverviewCard'
import OverviewSummaryBox from '../Components/Overview/OvervewComponents/OverviewSummaryBox'
import { useAppDispatch, useAppSelector } from '../redux/store'
import { fetchEvents } from '../redux/event/manageEvents/actions'
import { fetchAssignedTaskDetails } from '../redux/task/actions'
import { selectUserTeamMemberInfo } from '../redux/auth/selector'

const OverviewPage = () => {
  const dispatch = useAppDispatch()
  const teamMemberDetails = useAppSelector(selectUserTeamMemberInfo)

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchEvents())
        await dispatch(
          fetchAssignedTaskDetails({
            teamMemberWorkdayId: teamMemberDetails.workdayId,
            teamMemberEmail: teamMemberDetails.email,
          }),
        )
      } catch (error) {
        console.error('Error fetching team member events:', error)
      }
    }
    fetchData()
  }, [dispatch])

  return (
    <React.Fragment>
      <Box component='div' sx={{ p: 0, width: 'auto' }}>
        <OverviewCard />
        <Grid container mt={2} direction='column'>
          <OverviewSummaryBox />
        </Grid>
      </Box>
    </React.Fragment>
  )
}

export default OverviewPage
